// @flow

import React from 'react';
import { css } from '@emotion/core';

/**
 *
 * WARNING - THIS IMPLEMENTATION IS SPECIFICALLY A RE-IMPLEMENTATION OF THE
 * EXISTING AD SETUP. DO NOT USE AS A BASE FOR FUTURE WORK
 *
 */

let styles = css`
  margin-top: 16px;
`;

export default class DoNotUseMeAd extends React.Component<any> {
  shouldComponentUpdate(): boolean {
    return false;
  }

  render() {
    return <div
      css={styles}
      className="googletag-ad sidebar-ad"
      data-unit="tpt_schedule_300x250_mid"
      data-width="300"
      data-height="250"
      data-collapse="true"
      data-size-mappings=""
      data-target-key=""
      data-target-value=""/>;
  }
}